/**
 * OrderLineService
 * Service for OrderLine entity operations
 * Route: api/orderlines
 * Controller: OrderLinesController.cs
 */
import { CrudService } from '../base/CrudService';
import { validateOrderLineRequest } from '../../utils/validation';
/**
 * OrderLineService
 * Handles order line CRUD operations.
 * Backend now returns OrderLineModelView (enriched) instead of raw OrderLine entities.
 * Maps to /api/orderlines endpoint
 */
export class OrderLineService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? OrderLineService.DEFAULT_SERVICE_PATH,
            basePath: OrderLineService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== OVERRIDES WITH VALIDATION ====================
    /**
     * Create a new order line with price validation
     */
    async create(data) {
        validateOrderLineRequest(data);
        return super.create(data);
    }
    /**
     * Update an order line with price validation
     */
    async update(id, data) {
        if (data.unitPrice != null && data.quantity != null) {
            validateOrderLineRequest({
                unitPrice: data.unitPrice,
                quantity: data.quantity,
                amount: data.amount,
                basePrice: data.basePrice,
                variantAdditionalPrice: data.variantAdditionalPrice,
            });
        }
        return super.update(id, data);
    }
    // ==================== QUERY BY ORDER ====================
    /**
     * Get order lines by order ID
     * GET /api/orderlines?orderId={orderId}
     */
    async getByOrderId(orderId) {
        const response = await this.getByOrderIdRaw(orderId);
        return response.data ?? [];
    }
    /**
     * Get order lines by order ID (raw)
     */
    getByOrderIdRaw(orderId) {
        const url = this.buildUrl(`?orderId=${orderId}`);
        return this.http.get(url);
    }
}
OrderLineService.DEFAULT_SERVICE_PATH = 'orders';
OrderLineService.BASE_PATH = 'api/orderlines';
//# sourceMappingURL=OrderLineService.js.map